import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { ColorBaseWhite } from 'assets/styles/variables'
import { CircularProgressLoader } from 'components/global-progress-modal/global-progress-modal'

const useStyles = makeStyles((theme) => ({
    previewArea: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
    },
    documentContainer: {
        position: 'relative',
        maxWidth: '100%',
        maxHeight: '100%',
        backgroundColor: ColorBaseWhite,
        borderRadius: '0px',
        overflow: 'hidden',
        transition: 'transform 0.3s ease'
    },
    documentContainerZoomed: {
        transform: 'scale(1.05)'
    },
    imageContainer: {
        position: 'relative',
        maxHeight: '82vh',
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
            width: '8px'
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '0px'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '0px',
            '&:hover': {
                background: '#a8a8a8'
            }
        }
    },
    pageWrapper: {
        position: 'relative',
        marginBottom: theme.spacing(2),
        '&:last-child': {
            marginBottom: 0
        }
    },
    previewImage: {
        width: '605px',
        height: '812px',
        display: 'block'
    },
    pageOverlay: {
        position: 'absolute',
        top: '8px',
        right: '8px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        color: ColorBaseWhite,
        padding: '4px 8px',
        borderRadius: '0px',
        fontSize: '12px',
        fontWeight: 500,
        opacity: 0,
        transition: 'opacity 0.2s ease'
    },
    pageWrapperHovered: {
        '& $pageOverlay': {
            opacity: 1
        }
    },
    loadingContainer: {
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        borderRadius: '0px'
    }
}))

interface EnhancedPreviewTemplateProps {
    imageUrlsData?: string[]
    loading?: boolean
}

const EnhancedPreviewTemplate: React.FC<EnhancedPreviewTemplateProps> = ({
    imageUrlsData = [],
    loading = false
}) => {
    const classes = useStyles()
    const [hoveredPage, setHoveredPage] = useState<number | null>(null)

    const renderImages = () => (
        <>
            <div className={classes.imageContainer}>
                {imageUrlsData.map((imageUrl, index) => (
                    <div
                        key={index}
                        id={`preview-image-${index}`}
                        className={`${classes.pageWrapper} ${
                            hoveredPage === index ? classes.pageWrapperHovered : ''
                        }`}
                        onMouseEnter={() => setHoveredPage(index)}
                        onMouseLeave={() => setHoveredPage(null)}>
                        <img
                            src={imageUrl}
                            alt={`Template Preview Page ${index + 1}`}
                            className={classes.previewImage}
                        />
                        <div className={classes.pageOverlay}>Page {index + 1}</div>
                    </div>
                ))}
            </div>
        </>
    )

    return (
        <div className={classes.previewArea}>
            <div className={`${classes.documentContainer}`}>
                {loading && (
                    <div className={classes.loadingContainer}>
                        <CircularProgressLoader />
                    </div>
                )}
                {!loading && imageUrlsData.length > 0 && renderImages()}
            </div>
        </div>
    )
}

export default EnhancedPreviewTemplate
